export const getPercentChange = (yesterday: number, current: number) => {
  if (yesterday === 0) {
    return current === 0 ? 0 : 100
  }
  return ((current - yesterday) / yesterday) * 100
}
